import { Injectable } from '@angular/core';
import { PscHttpService } from './psc-http.service';
import { ContactQueryRequest } from '../common/models/contact/contact-query-request';

@Injectable({
  providedIn: 'root',
})
export class ContactService {
  baseEndpoint = 'contact/';

  constructor(
    private httpService: PscHttpService,
  ) {
  }

  sendContactQuery(contactQueryRequest: ContactQueryRequest) {
    return this.httpService.post(`${ this.baseEndpoint }contactUs`, contactQueryRequest);
  }

}
